import { render, staticRenderFns } from "./create-unit.vue?vue&type=template&id=5edfddd7&"
import script from "./create-unit.vue?vue&type=script&lang=ts&"
export * from "./create-unit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports